var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcValueShipping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.625 7.5H30V0H3.75C1.6875 0 0 1.6875 0 3.75V24.375H3.75C3.75 27.4875 6.2625 30 9.375 30C12.4875 30 15 27.4875 15 24.375H26.25C26.25 27.4875 28.7625 30 31.875 30C34.9875 30 37.5 27.4875 37.5 24.375H41.25V15L35.625 7.5ZM34.6875 10.3125L38.3625 15H30V10.3125H34.6875ZM9.375 26.25C8.34375 26.25 7.5 25.4062 7.5 24.375C7.5 23.3438 8.34375 22.5 9.375 22.5C10.4062 22.5 11.25 23.3438 11.25 24.375C11.25 25.4062 10.4062 26.25 9.375 26.25ZM13.5375 20.625C12.5063 19.4813 11.0437 18.75 9.375 18.75C7.70625 18.75 6.24375 19.4813 5.2125 20.625H3.75V3.75H26.25V20.625H13.5375ZM31.875 26.25C30.8438 26.25 30 25.4062 30 24.375C30 23.3438 30.8438 22.5 31.875 22.5C32.9062 22.5 33.75 23.3438 33.75 24.375C33.75 25.4062 32.9062 26.25 31.875 26.25Z",
    fill: "#F54253"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcValueShipping);
export default __webpack_public_path__ + "static/media/ic_value_shipping.425ad187b3650f49f1b91d47ab7add87.svg";
export { ForwardRef as ReactComponent };